import { useEffect } from "react";
import { useLanguage } from "../i18n";

function setMeta(attr, name, content) {
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function usePageMeta(titleKey, descKey, vars, imageUrl) {
  const { t } = useLanguage();
  const varsJson = JSON.stringify(vars || {});
  useEffect(() => {
    const v = JSON.parse(varsJson);
    const fill = (s) => Object.entries(v).reduce((acc, [k, val]) => acc.split(`{${k}}`).join(val), s);
    const ttl = fill(t(titleKey));
    const dsc = fill(t(descKey));
    document.title = ttl;
    setMeta("name", "description", dsc);
    setMeta("property", "og:title", ttl);
    setMeta("property", "og:description", dsc);
    if (imageUrl) {
      setMeta("property", "og:image", imageUrl);
      setMeta("name", "twitter:card", "summary_large_image");
      setMeta("name", "twitter:image", imageUrl);
    }
  }, [t, titleKey, descKey, varsJson, imageUrl]);
}
